import * as React from "react";

import {widgetStyles} from "@client/forms/widgets";

interface Props {
    left: React.ReactNode;
    right: React.ReactNode;
    lopsided?: {left: number; right: number};
}

export const DoubleWidget = (props: Props) => (
    <div className={widgetStyles.doubleField}>
        <div style={{flex: props.lopsided?.left ?? 1}}>{props.left}</div>
        <div style={{flex: props.lopsided?.right ?? 1}}>{props.right}</div>
    </div>
);
